export var rendererEventHandlers = {
  link: {
    onClick: function onClick(event, url) {
      // Intercept link event and open in another window stripping any opener or referrer info
      event.preventDefault();
      window.open(url, '_blank', 'noopener noreferrer');
    }
  }
};